import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Do you offer broken window repair near me?',
    a: 'Kosin’s Glass serves Howell, Ann Arbor, Novi and many surrounding Southeast Michigan communities. Request a free in-home estimate and the team will confirm availability for your location and project.'
  }, {
    q: 'Can you replace window glass only instead of the whole window?',
    a: 'Yes, when the existing frame is still in good condition, glass-only replacement may be a smart option. Kosin’s Glass can inspect your window and explain whether repairing or replacing the glass makes sense.'
  }, {
    q: 'Can you repair foggy double-pane windows?',
    a: 'Fog or condensation between panes usually means an insulated glass seal has failed. Kosin’s Glass can inspect the window and recommend seal repair, insulated glass replacement or another appropriate solution.'
  }, {
    q: 'What measurements do you need for a rough quote?',
    a: 'For a rough quote, measure the visible glass width and height in inches and take a clear photo if possible. Kosin’s Glass will take exact measurements before ordering or installing replacement glass.'
  }, {
    q: 'Do you replace door glass?',
    a: 'Yes. Kosin’s Glass replaces entry door glass, patio door glass, storm door glass, decorative glass inserts and other residential door glass.'
  }, {
    q: 'Do you install custom glass shower doors?',
    a: 'Yes. Kosin’s Glass designs and installs custom glass shower doors and enclosures, including frameless, semi-frameless, sliding and Euro-style options.'
  }, {
    q: 'Do you make custom mirrors?',
    a: 'Yes. Kosin’s Glass can help with bathroom mirrors, vanity mirrors, home gym mirrors, wall mirrors, beveled mirrors, tinted mirrors, etched mirrors and custom-shaped mirrors.'
  }, {
    q: 'Do you replace glass table tops and shelves?',
    a: 'Yes. Kosin’s Glass can measure and fabricate custom glass table tops, shelves, cabinet glass, decorative glass and specialty residential glass.'
  }, {
    q: 'Do you repair window screens and door screens?',
    a: 'Yes. Kosin’s Glass can repair damaged window screens and door screens by replacing the screen material.'
  }, {
    q: 'Is same-day residential glass service available?',
    a: 'Same-day openings may be available depending on the glass type, project, schedule and whether materials are in stock. Request an estimate or call the Howell service center to check availability.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <div className="text-center mb-12" data-id="element-54">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-55">
            Residential Glass Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className={`border rounded-xl transition-colors ${isOpen ? 'border-brandBlue-200 bg-brandBlue-50/30' : 'border-slate-200 bg-white'}`} data-id="element-57">
                <button className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-500 rounded-xl" onClick={() => setOpenIdx(isOpen ? null : idx)} aria-expanded={isOpen} data-id="element-58">
                  <span className="text-lg font-bold text-navy-900 pr-8" data-id="element-59">
                    {faq.q}
                  </span>
                  {isOpen ? <ChevronUp className="w-6 h-6 text-brandBlue-600 flex-shrink-0" data-id="element-60" /> : <ChevronDown className="w-6 h-6 text-slate-400 flex-shrink-0" data-id="element-61" />}
                </button>
                {isOpen && <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" data-id="element-62">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}